"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tryCatch = void 0;

/**
 * Replicate try/catch using a tryer and catcher function
 *
 * @param {Function} tryer   Try to do something with source input
 * @param {Function} catcher Run if tryer throws exception
 *
 * @return {any}
 *
 * @tag Core
 *
 * @example
 * tryCatch(inc)(10)
 * // => 11
 *
 * tryCatch(
 *   () => { throw new Error("Tryer error") },
 *   (error, source) => inc(source)
 * )(10)
 * // => 11
 */
var tryCatch = function tryCatch(tryer, catcher) {
  return function () {
    for (var _len = arguments.length, source = new Array(_len), _key = 0; _key < _len; _key++) {
      source[_key] = arguments[_key];
    }

    try {
      return tryer.apply(void 0, source);
    } catch (error) {
      return catcher.apply(void 0, [error].concat(source));
    }
  };
};

exports.tryCatch = tryCatch;